import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { restrictLoggedOut } from '@wix/da-shared-react/pkg/redux/loggedout/actionCreators';
import { AppState } from '../../../../../../types/store';
import {
  getProfileOwnerIsWatcher,
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../../selectors/users';
import { blockProfileOwner } from '../../../../../actions/profileOwner';
import { Props } from './UserProfileSubNavDesktopInner';

type StateProps = Pick<
  Props,
  | 'isOwner'
  | 'profileOwnerUser'
  | 'isProfileOwnerWatchingCurrentUser'
  | 'isLoggedIn'
>;
type DispatchProps = Pick<Props, 'restrictLoggedOut' | 'blockProfileOwner'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isOwner: isCurrentUserProfileOwner(state),
  profileOwnerUser: getProfileOwnerUser(state),
  isProfileOwnerWatchingCurrentUser: getProfileOwnerIsWatcher(state),
  isLoggedIn: getIsLoggedIn(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  restrictLoggedOut: payload => dispatch(restrictLoggedOut(payload)),
  blockProfileOwner: () => dispatch(blockProfileOwner()),
});

export default connect(mapStateToProps, mapDispatchToProps);
